var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};
var fmt = {
  lowercase: v => v.toLowerCase()
};

module.exports = {
  metaData: {
    "default": {
      title: function(d) { return "Manage account | The Outnet"; },
      description: function(d) { return "350+ designers at up to 70% off. Everything reduced but the thrill!"; },
      keywords: function(d) { return "Next Day Delivery On Iconic Brands And New Arrivals To The Site Every Week. On Orders over £300. Free Express Shipping. Brands: Tory Burch, Alexander Wang, Dolce & Gabbana, Isabel Marant, Emilio Pucci."; }
    }
  },
  languages: {
    en: function(d) { return "English"; },
    ar: function(d) { return "اللغة العربية"; },
    de: function(d) { return "Deutsche"; },
    fr: function(d) { return "Française"; },
    ja: function(d) { return "Japanese"; },
    ko: function(d) { return "Korean"; }
  },
  titles: {
    mr: function(d) { return "Mr"; },
    ms: function(d) { return "Ms"; },
    mrs: function(d) { return "Mrs"; },
    miss: function(d) { return "Miss"; },
    sir: function(d) { return "Sir"; },
    dr: function(d) { return "Dr"; },
    lord: function(d) { return "Lord"; },
    prof: function(d) { return "Prof"; },
    rev: function(d) { return "Rev"; },
    other: function(d) { return "Other"; }
  },
  menu: function(d) { return "Menu"; },
  pages: {
    myAccountLanding: {
      title: function(d) { return "Your Account"; },
      description: function(d) { return ""; }
    },
    preferences: {
      title: function(d) { return "Marketing Preferences"; },
      description: function(d) { return "Tailor your emails from us"; }
    },
    myorders: {
      title: function(d) { return "My Orders"; },
      description: function(d) { return "Track your order or create a return"; }
    },
    savedcards: {
      title: function(d) { return "Card Wallet"; },
      description: function(d) { return "View and manage your payment methods"; }
    },
    orderdetails: {
      title: function(d) { return "Order Details"; },
      description: function(d) { return "View order details"; }
    },
    wishlist: {
      title: function(d) { return "Wish List"; },
      description: function(d) { return "Save the items you love for later and make sure you don't miss out!"; }
    },
    addressBook: {
      title: function(d) { return "Address Book"; },
      description: function(d) { return "Manage your addresses"; }
    },
    accountdetails: {
      title: function(d) { return "Account Details"; },
      description: function(d) { return "Change your sign in information"; }
    },
    accountDetailsForm: {
      title: function(d) { return "Account Details Form"; },
      description: function(d) { return "Form to update account details section"; }
    },
    privacy: {
      title: function(d) { return "Privacy Settings"; },
      description: function(d) { return "View and manage your privacy settings"; }
    },
    managecards: {
      title: function(d) { return "Manage Cards"; },
      description: function(d) { return "View and update saved payment information"; }
    },
    orderdetailsReturn: {
      title: function(d) { return "Return Items"; },
      description: function(d) { return ""; }
    },
    guestorderdetails: {
      title: function(d) { return ""; },
      description: function(d) { return ""; }
    },
    referAFriend: {
      title: function(d) { return "Refer a Friend"; },
      description: function(d) { return "Recommend THE OUTNET to your friends and earn rewards"; }
    },
    credits: {
      title: function(d) { return "Store Credit"; },
      description: function(d) { return "Check your balance and transactions"; }
    }
  },
  myAccountLanding: {
    title: function(d) { return "Welcome to your Account"; },
    pageError: function(d) { return "We're sorry something went wrong."; },
    retryNow: function(d) { return "Retry Now"; }
  },
  address: {
    primaryInfo: function(d) { return "Default " + select(d.type, { both: "shipping & billing", shipping: "shipping", billing: "billing", other: "" }) + " address"; }
  },
  addressBook: {
    title: function(d) { return "Address Book"; },
    editTitle: function(d) { return "Edit Address"; },
    addTitle: function(d) { return "Add a New Address"; },
    "delete": function(d) { return "Delete"; },
    undo: function(d) { return "Undo"; },
    edit: function(d) { return "Edit"; },
    deleted: function(d) { return "You deleted the address:"; },
    saved: function(d) { return select(d.type, { update: "You have updated the address: " + d.addressLine, other: "All done - you have added a new address: " + d.addressLine }); },
    description: function(d) { return "Manage your addresses"; },
    addAddressLink: function(d) { return "Add an address"; },
    deleteError: function(d) { return "There was a problem deleting the address"; },
    emptyAddressesTitle: function(d) { return "You have no saved addresses"; },
    emptyAddressesDetails: function(d) { return "Add an address for a fast checkout"; },
    emptyAddressLinkTitle: function(d) { return "Add an Address"; },
    pageError: function(d) { return "We're sorry something went wrong."; },
    retryNow: function(d) { return "Retry Now"; }
  },
  addressForm: {
    save: function(d) { return "Save"; },
    select: function(d) { return "Select " + fmt.lowercase(d.select, "en"); },
    display: {
      city: function(d) { return "City"; },
      country: function(d) { return "Country"; },
      personTitle: function(d) { return "Title"; },
      firstName: function(d) { return "First name"; },
      lastName: function(d) { return "Last name"; },
      addressLine_1: function(d) { return "Address line one"; },
      addressLine_2: function(d) { return "Address line two"; },
      cityTownVillage: function(d) { return "City/Town/Village"; },
      streetName: function(d) { return "Street Name"; },
      buildingName: function(d) { return "Building Name"; },
      district: function(d) { return "District"; },
      county: function(d) { return "County"; },
      pronunciationFirstName: function(d) { return "Pronunciation First Name"; },
      pronunciationLastName: function(d) { return "Pronunciation Last Name"; },
      phone: function(d) { return "Phone number"; },
      alternatePhone: function(d) { return "Alternate number"; },
      province: function(d) { return "Province"; },
      state: function(d) { return "State"; },
      region: function(d) { return "Region"; },
      area: function(d) { return "Area"; },
      zipCode: function(d) { return "ZIP code"; },
      postCode: function(d) { return "Postcode"; },
      eircode: function(d) { return "Eircode"; },
      pccc: function(d) { return "PCCC"; },
      taxId: function(d) { return "Tax ID"; }
    },
    help: {
      pccc: function(d) { return "Enter your PCCC number (e.g. P + 12 digits)"; },
      taxId: function(d) { return "Your Indonesian TAX ID (NPWP) number is required for your shipment to clear Indonesian customs."; },
      Eircode: function(d) { return "e.g. A65 F4E2"; }
    }
  },
  accountDetails: {
    title: function(d) { return "Account Details"; },
    fullName: function(d) { return d.firstName + " " + d.lastName; },
    description: function(d) { return "Change your Sign In information"; },
    personalInfo: function(d) { return "Personal Information"; },
    email: function(d) { return "Email Address"; },
    dob: function(d) { return "Born on " + d.dob; },
    password: function(d) { return "Password"; },
    passwordDots: function(d) { return "●●●●●●●●●●●●"; },
    edit: function(d) { return "Edit"; },
    cancel: function(d) { return "Cancel"; },
    updated: function(d) { return "All done, your " + select(d.updateUserSuccess, { personalInfo: "personal information", changeEmail: "email address", changePassword: "password", other: "information" }) + " has been updated"; },
    pageError: function(d) { return "We're sorry, something went wrong."; },
    retryNow: function(d) { return "Retry Now"; }
  },
  returnsAndExchangesForm: {
    exchangeLabel: function(d) { return "Exchange"; },
    returnLabel: function(d) { return "Return"; },
    selectReasonReturn: function(d) { return "Select a reason"; },
    selectReasonExchange: function(d) { return "Select a reason"; },
    reasonLabel: function(d) { return "Tell us why"; },
    sizesAndColoursTitle: function(d) { return "Choose another size"; },
    colourLabel: function(d) { return "Color"; },
    sizeLabel: function(d) { return "Size"; },
    submit: function(d) { return "Continue"; },
    other: function(d) { return "Other..."; },
    requiredReturnCode: function(d) { return "Please select a reason"; },
    requiredReturnNote: function(d) { return "Return reason note is mandatory"; },
    requiredSize: function(d) { return "Size is required"; },
    requiredReturnType: function(d) { return "Return type required"; },
    refundLabel: function(d) { return "I'd prefer a refund"; }
  },
  refundForm: {
    termsAndConditionsError: function(d) { return "Please accept the terms and conditions to continue"; },
    conditionsTitle: function(d) { return "Conditions For Return"; },
    conditions: function(d) { return "Please make sure your items are returned new, unused, and with tags attached"; },
    termsAndConditions: function(d) { return "I’ve read and do accept THE OUTNET returns policy"; },
    seeMore: function(d) { return "Find out more"; },
    submit: function(d) { return "Confirm"; },
    refundMethodTitle: function(d) { return "Preferred Refund Method"; },
    refundCard: function(d) { return "Refund to Credit / Debit Card"; },
    refundCardInfo: function(d) { return select(d.showStoreCreditFirst, { true: "Refunds can take up to **10 working days** to show on your account, depending on your payment issuer", other: "Your refund will be issued to the original payment method you chose" }); },
    refundAsCharged: function(d) { return "Original payment method"; },
    refundAsChargedInfo: function(d) { return select(d.showStoreCreditFirst, { true: "Refunds can take up to **10 working days** to show on your account, depending on your payment issuer", other: "Your refund will be issued to the original payment method you chose" }); },
    storeCredit: function(d) { return "Refund as Store Credit"; },
    storeCreditInfo: function(d) { return select(d.showStoreCreditFirst, { true: "Your refund will be issued in store credit to your The Outnet account as soon as your return has been processed", other: "Valid for use within 12 months from today" }); },
    storeCreditBanner: function(d) { return "FASTER FOR CUSTOMER"; }
  },
  colourAndSize: {
    colour: function(d) { return "Color"; },
    moreColours: function(d) { return "More colors"; }
  },
  sizes: {
    sizeLabel: function(d) { return "Size"; },
    initialValue: function(d) { return "Select a size"; },
    oneSizeLabel: function(d) { return "Only one size left"; },
    viewSizeGuide: function(d) { return "Size Guide"; },
    sizeGuide: {
      viewSizeGuide: function(d) { return "Need Help finding your size? View our <u>Size Guide</u>"; },
      title: function(d) { return "Size Guide"; }
    }
  },
  considered: {
    badge: function(d) { return "Considered"; }
  },
  changeEmailForm: {
    currentEmail: function(d) { return "Current Email Address"; },
    newEmail: function(d) { return "New Email Address"; },
    password: function(d) { return "Current Password"; },
    update: function(d) { return "Update"; }
  },
  changePasswordForm: {
    currentPassword: function(d) { return "Current Password"; },
    newPassword: function(d) { return "New Password"; },
    confirmPassword: function(d) { return "Confirm new password"; },
    update: function(d) { return "Update Password"; },
    passwordRequirements: function(d) { return "Use at least 8 characters. Include both an uppercase letter and a number"; }
  },
  loginAndRegistrationForm: {
    hasAccountTitle: function(d) { return "Welcome"; },
    hasAccountSubTitle: function(d) { return "Please enter your email address"; },
    noAccountTitle: function(d) { return "Register now"; },
    noAccountSubTitle: function(d) { return "Set up an account to shop more easily"; },
    logonId: function(d) { return "Email Address"; },
    hasAccount: function(d) { return "I'm already registered"; },
    noAccount: function(d) { return "I'm new to THE OUTNET"; },
    forgotPassword: function(d) { return ""; },
    forgotPasswordLinkTitle: function(d) { return "Forgot your password?"; },
    submit: function(d) { return select(d.hasAccount, { true: "Sign In", other: "Register" }); },
    languageRegistrationPrompt: function(d) { return "Please enter the following fields in English"; }
  },
  loginForm: {
    login: function(d) { return "Sign In"; },
    logonId: function(d) { return "Email Address"; },
    logonPassword: function(d) { return "Password"; }
  },
  loginConsent: {
    title: function(d) { return "Changes on our Site"; },
    overlayBody1: function(d) { return "We have updated our Account Terms & Conditions and Privacy Policy since you last visited our site. Please read below and agree before proceeding."; },
    overlayBody2: function(d) { return "By clicking agree you confirm to have read and understood the THE OUTNET Account Terms and Conditions & Privacy Policy."; },
    pleaseNote1: function(d) { return "Please Note if you"; },
    dontProceed: function(d) { return "don't proceed"; },
    pleaseNote2: function(d) { return "we won't be able to complete your registration and you will need to continue as a guest. The Terms and Conditions and Privacy Policy will still apply if you check out as a guest."; },
    termsAndConditions: function(d) { return "Terms and Conditions"; },
    privacyPolicy: function(d) { return "Privacy Policy"; },
    submit: function(d) { return "Agree"; },
    and: function(d) { return "and"; }
  },
  registrationForm: {
    register: function(d) { return "Register"; },
    logonId: function(d) { return "Email Address"; },
    logonPassword: function(d) { return "Create New Password"; },
    personTitle: function(d) { return "Title"; },
    firstName: function(d) { return "First Name"; },
    lastName: function(d) { return "Last Name"; },
    phone1: function(d) { return ""; },
    dateOfBirth: function(d) { return "Date of birth (optional)"; },
    day: function(d) { return "Day"; },
    month: function(d) { return "Month"; },
    year: function(d) { return "Year"; },
    receiveEmailPreference: function(d) { return "Sign up to newsletter"; },
    maMarketingConsent: function(d) { return "Subscribe to exclusive THE OUTNET and other LuxExperience B.V. brands content to receive 10% off your next THE OUTNET order."; },
    discountDisclaimer: function(d) { return "[Exclusions apply - see T&Cs](https://www.theoutnet.com/page/policies/general-terms-and-conditions-of-sale/#promotional-codes)."; },
    marketingYes: function(d) { return "Yes please!"; },
    marketingNo: function(d) { return "No thanks"; },
    selectTitle: function(d) { return "Select title"; },
    other: function(d) { return "Other..."; },
    privacyPolicy: function(d) { return "Find out more about our "; },
    privacyPolicyTitle: function(d) { return "Privacy Policy"; },
    emailReadMore: function(d) { return "What will I receive?"; },
    emailInfo: function(d) { return "By ticking the checkbox, you will sign up to THE OUTNET and other LuxExperience B.V.* brands email marketing communications containing the newest arrivals at exceptional prices, expert styling advice, our latest (and best) promotions.\n\nYou can opt out at any time by managing your preferences in your account or by following the instructions provided in each communication.\n\n*LuxExperience B.V. includes the following brands:  Mr Porter, Mytheresa, Net-A-Porter, The Outnet, YOOX.\n\nWhen you visit, use our websites and/or applications, including services provided thereon, your information will be processed in accordance with the respective Privacy Policy of each brand: [Mr Porter](https://www.mrporter.com/content/help/privacy-policy/), [Mytheresa](https://www.mytheresa.com/to/service/privacy-policy), [Net-A-Porter](https://www.net-a-porter.com/content/help/privacy-policy/), [The Outnet](https://www.theoutnet.com/page/policies/privacy-policy/), [YOOX](https://www.yoox.com/Legal/Privacypolicy)."; },
    emailTitle: function(d) { return "Our Emails"; },
    termsAndConditions: function(d) { return "By registering you accept you have read and understood THE OUTNET "; },
    termsAndConditionsLink: function(d) { return "Account Terms and Conditions"; },
    marketingError: function(d) { return "Please select an option to complete your registration"; },
    autoYesExplanation: function(d) { return "Select 'No thanks' if you'd prefer not to receive promotional emails from us"; },
    genderMens: function(d) { return "Men"; },
    genderWomens: function(d) { return "Women"; },
    genderAll: function(d) { return "All"; },
    genderSelectionLabel: function(d) { return "Please select your preference"; },
    gdprConsentTerms: function(d) { return "I agree to the [Account Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/)."; },
    gdprConsentPrivacy: function(d) { return "Personal data provided by you will be processed for account registration purposes in accordance with our [Privacy Policy](https://www.theoutnet.com/" + d.locale + "/page/policies/privacy-policy/)."; },
    gdprConsentError: function(d) { return "Required field"; },
    checkAll: function(d) { return "Check all"; },
    ageConsent: function(d) { return "I confirm that I am 14 years old or older (mandatory)"; },
    tcConsent: function(d) { return "Consent to [the collection and use of personal information]() (mandatory)"; },
    newsletterConsent: function(d) { return "[I consent to the collection and use of my personal information]() for marketing purposes in order to be updated via email on news, latest arrivals, promotional initiatives of THEOUTNET and other LuxExperience B.V. brands as part of our targeted marketing activities (optional)"; },
    termsAndConditionsAcceptance: function(d) { return "By registering you accept you have read and understood THE OUTNET [Account Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/) and [Privacy Policy](https://www.theoutnet.com/" + d.locale + "/page/policies/privacy-policy/).\n\nBy clicking Register, you agree to join our Rewards Programme as regulated under these [Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/general-terms-and-conditions-of-sale/#outnet-rewards) and enjoy the additional benefits listed in [My Account Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/)."; }
  },
  marketingPreferences: {
    pageError: function(d) { return "Sorry, something went wrong"; },
    retryNow: function(d) { return "Try again"; },
    emptyLabel: function(d) { return "Please select..."; },
    countryLangSectionTitle: function(d) { return "Preferred country and language"; },
    countryLangSectionText: function(d) { return "Please specify the country from which you are shopping, and the language in which you wish to receive our communications."; }
  },
  emailPasswordTokenForm: {
    title: function(d) { return "Forgot Password"; },
    info: function(d) { return "We will send you an email with a link to create a new password"; },
    logonId: function(d) { return "Email Address"; },
    cancel: function(d) { return "Cancel"; },
    send: function(d) { return "Send"; },
    sentEmailSuccess: function(d) { return "If there’s a registered account associated with the email address provided, we’ll send you an email with a link to reset your password shortly"; },
    backToLogin: function(d) { return "Back to Sign In"; },
    confirmation: function(d) { return "All done!"; }
  },
  forgotPassword: {
    cancel: function(d) { return "Cancel"; }
  },
  resetPasswordForm: {
    title: function(d) { return "New Password"; },
    logonId: function(d) { return "Email Address"; },
    createPassword: function(d) { return "Create a new password"; },
    confirmPassword: function(d) { return "Confirm new password"; },
    submit: function(d) { return "Sign In"; },
    resetSuccess: function(d) { return "All done, your password is updated. You can now sign in with your new password."; },
    "continue": function(d) { return "Continue to Sign-in"; },
    confirmation: function(d) { return "Thanks !"; }
  },
  orderHistory: {
    title: function(d) { return "My Orders"; },
    description: function(d) { return "View your orders to see what you've purchased or track their delivery"; },
    terms: function(d) { return "If your purchase isn't quite what you're looking for, you've got " + d.returnWindow + " days from when you received your order to have your items sent back to us for a refund or exchange."; },
    noOrdersTitle: function(d) { return "You have no orders"; },
    noOrdersDescription: function(d) { return "Once you have checked out you can view and track your order here"; },
    paginationDetails: function(d) { return "Showing " + d.totalOrdersDisplayed + " of " + d.totalOrders + " orders"; },
    loadMore: function(d) { return "See More"; },
    noOrdersLinkTitle: function(d) { return "Shop What's New"; },
    errorLoadingMoreOrders: function(d) { return "Sorry we could not load more orders, please try again "; },
    errorLoadingMorePastOrders: function(d) { return "Sorry we could not load more past orders "; },
    pageError: function(d) { return "We're sorry something went wrong. "; },
    retryButton: function(d) { return "Retry Now"; },
    recentOrders: function(d) { return select(d.error, { false: "Recent Orders (" + d.totalOrders + ")", true: "Recent Orders", other: "" }); },
    pastOrders: function(d) { return select(d.error, { false: "Previous Orders (" + d.totalOrders + ")", true: "Previous Orders", other: "" }); },
    canBeExchanged: function(d) { return ""; },
    canBeRefunded: function(d) { return ""; },
    cannotBeExchanged: function(d) { return ""; },
    cannotBeRefunded: function(d) { return ""; },
    customerCare: function(d) { return "Customer Care"; }
  },
  orderItem: {
    orderId: function(d) { return "Order " + d.displayId; },
    date: function(d) { return "Date: " + d.placedDate; },
    price: function(d) { return "Total: " + d.price; },
    viewDetails: function(d) { return "View Details"; },
    trackOrder: function(d) { return "Track My Order"; },
    trackExchange: function(d) { return "Track Exchange"; }
  },
  orderStatus: {
    pending: function(d) { return "Processing"; },
    cancelled: function(d) { return "Cancelled"; },
    dispatched: function(d) { return "Dispatched"; },
    exchangeReceived: function(d) { return "Exchange Received"; },
    exchanged: function(d) { return "Exchanged"; },
    ordered: function(d) { return "Order Placed"; },
    processing: function(d) { return "Preparing Your Order"; },
    returnCompleted: function(d) { return "Return Completed"; },
    returnReceived: function(d) { return "Return Received"; },
    returnRequest: function(d) { return "Return Request"; },
    returned: function(d) { return "Returned"; },
    viewDetails: function(d) { return "View details"; },
    returnRequested: function(d) { return "Return Requested"; },
    returnRefused: function(d) { return "Return not accepted"; },
    exchangeOrdered: function(d) { return "Exchange ordered"; },
    exchangeProcessing: function(d) { return "Exchange processing"; },
    inTransit: function(d) { return "With Courier"; },
    delivered: function(d) { return "Delivered"; },
    returnProcessing: function(d) { return "Return Under Review"; },
    returnInTransit: function(d) { return "Return In Transit"; },
    returnRefunded: function(d) { return "Return Refunded"; },
    partiallyReturnRefunded: function(d) { return "Return Partially Refunded"; },
    partiallyReturnRefused: function(d) { return "Part of your return has not been accepted"; },
    returnAccepted: function(d) { return "Return Accepted"; }
  },
  orderItemStatus: {
    RETURN_REQUESTED: function(d) { return "Return Request"; },
    RETURN_ACCEPTED: function(d) { return "Return Accepted"; },
    RETURN_REFUNDED: function(d) { return "Return Refunded"; },
    RETURN_REFUSED: function(d) { return "Return Refused"; },
    CANCELLED: function(d) { return "Cancelled"; },
    EXCHANGE_ACCEPTED: function(d) { return "Exchange Received"; },
    EXCHANGED: function(d) { return "Exchanged"; }
  },
  orderEvents: {
    TRANSFERRED: function(d) { return "We're waiting to receive your items from our European location"; },
    SCHEDULED: function(d) { return "We’re ready to pack your order"; },
    RELEASED: function(d) { return "Your order is ready, it’ll be on its way to you soon"; },
    TRANSIT_001: function(d) { return "Out for delivery"; },
    TRANSIT_002: function(d) { return "Your order is being kept safe before it's delivered"; },
    TRANSIT_003: function(d) { return "Your order has arrived in your location"; },
    EXCEPTION_001: function(d) { return "Delivery attempted"; },
    EXCEPTION_002: function(d) { return "Customs delay"; },
    EXCEPTION_003: function(d) { return "Delivery delayed"; },
    EXCEPTION_004: function(d) { return "Incorrect address. Contact Customer Care"; },
    EXCEPTION_005: function(d) { return "Your order is coming back to us"; },
    EXCEPTION_006: function(d) { return "Your order has arrived back with us"; },
    EXCEPTION_007: function(d) { return "Recipient not available at the given address"; },
    EXCEPTION_008: function(d) { return "Business is closed at the time of delivery"; },
    EXCEPTION_009: function(d) { return "Delivery of the package failed due to some shipping exception"; },
    EXCEPTION_010: function(d) { return "Delivery of the package failed as the customer relocated"; },
    EXCEPTION_011: function(d) { return "Delivery of the package failed as the recipient refused to take the package due to some reason"; },
    EXCEPTION_012: function(d) { return "The package being held due to pending payment from the customer's end"; },
    EXCEPTION_013: function(d) { return "Package available for the pickup but not collected by the customer"; },
    EXCEPTION_014: function(d) { return "Package rejected by the carrier due to noncompliance with its guidelines"; },
    EXCEPTION_015: function(d) { return "Shipment damaged"; },
    EXCEPTION_016: function(d) { return "Delivery of the package failed as it got lost"; }
  },
  returnEvents: {
    TRANSIT_001: function(d) { return "Your return is on the way"; },
    TRANSIT_002: function(d) { return "Your return is at your local hub or sorting facility"; },
    TRANSIT_003: function(d) { return "Your return has arrived in " + d.country; },
    EXCEPTION_001: function(d) { return "Your return wasn't successfully delivered but will be reattempted soon"; },
    EXCEPTION_002: function(d) { return "Your return is delayed at customs"; },
    EXCEPTION_003: function(d) { return "Your return is delayed"; },
    EXCEPTION_004: function(d) { return "Incorrect address. Contact Customer Care"; },
    EXCEPTION_005: function(d) { return "Your return is coming back to you"; },
    EXCEPTION_006: function(d) { return "Your return has arrived back with you"; },
    EXCEPTION_007: function(d) { return "Recipient not available at the given address"; },
    EXCEPTION_008: function(d) { return "Business is closed at the time of delivery"; },
    EXCEPTION_009: function(d) { return "Delivery of the package failed due to some shipping exception"; },
    EXCEPTION_010: function(d) { return "Delivery of the package failed as the customer relocated"; },
    EXCEPTION_011: function(d) { return "Delivery of the package failed as the recipient refused to take the package due to some reason "; },
    EXCEPTION_012: function(d) { return "The package being held due to pending payment from the customer's end"; },
    EXCEPTION_013: function(d) { return "Package available for the pickup but not collected by the customer"; },
    EXCEPTION_014: function(d) { return "Package rejected by the carrier due to noncompliance with its guidelines"; },
    EXCEPTION_015: function(d) { return "Shipment damaged"; },
    EXCEPTION_016: function(d) { return "Delivery of the package failed as it got lost"; },
    RETURN_RECEIVED: function(d) { return "Your return has been received"; },
    RETURN_ACCEPTED: function(d) { return "Your return has been accepted"; },
    PARTIALLY_RETURN_ACCEPTED: function(d) { return "Part of your return has been accepted"; }
  },
  orderStatusDesc: {
    ordered: function(d) { return "We'll start preparing your order soon"; },
    processing: function(d) { return "We're preparing your order"; },
    dispatched: function(d) { return "Your order has now left us"; },
    inTransit: function(d) { return "Your order is on its way to you"; },
    delivered: function(d) { return ""; },
    cancelled: function(d) { return "Your order has been cancelled. If you didn't request this and need more information, please contact Customer Care by " + d.phone + " or " + d.mail; },
    returnRefused: function(d) { return "Sorry, your return hasn't been accepted. For more information, contact Customer Care by " + d.phone + " or " + d.mail; },
    phone: function(d) { return "phone"; },
    email: function(d) { return "email"; }
  },
  orderDetails: {
    title: function(d) { return "Order Details"; },
    orderInfo: function(d) { return "Thanks for your order " + d.userTitle + " " + d.userLastName + ". Your order number is "; },
    orderItemsTitle: function(d) { return "What You Ordered"; },
    returnsConditions: function(d) { return "You have " + d.returnWindow + " days from the day your order is delivered to request an exchange or return and send your purchase back."; },
    quantity: function(d) { return "Quantity: " + d.quantity; },
    totalsTitle: function(d) { return "Order Summary"; },
    trackOrder: function(d) { return "Track My Order"; },
    trackReturn: function(d) { return "Track My Return"; },
    trackExchange: function(d) { return "Track My Exchange"; },
    dateShipped: function(d) { return "Your order " + d.displayId + " is on its way and was shipped on " + d.dateShipped + "."; },
    timeDelivered: function(d) { return "Your order was delivered on " + d.timeDelivered + ". You have " + d.returnWindow + " days from the delivery date to return items."; },
    timeExchangeDelivered: function(d) { return "Your order was delivered on " + d.timeDelivered + ". You have " + d.returnWindow + " days from the delivery date to exchange or return items."; },
    pageError: function(d) { return "We're sorry something went wrong."; },
    retryButton: function(d) { return "Retry Now"; },
    createExchange: function(d) { return "Create Exchange/Return"; },
    createReturn: function(d) { return "Create Return"; },
    review: function(d) { return "Continue"; },
    cancel: function(d) { return "Cancel"; },
    cancelReturn: function(d) { return "Cancel Return"; },
    reviewChanges: function(d) { return "Review changes"; },
    edit: function(d) { return "Edit"; },
    returnStatus: function(d) { return select(d.type, { "return": "Return requested", exchange: "Exchange requested", other: "" }); },
    returnTitle: function(d) { return "Return Items"; },
    exchangeTitle: function(d) { return "Exchange or Return"; },
    exchangeReturn: function(d) { return "Create Exchange / Return"; },
    "return": function(d) { return "Return"; },
    confirmReturnTitle: function(d) { return "Confirm Return"; },
    confirmMessage: function(d) { return "Please verify and confirm the item(s) you want to return."; },
    returnConfirmation: function(d) { return "Thank you for your request " + d.name; },
    returnConfirmationMessage: function(d) { return "We have sent an email to " + d.email + " with all the info you need to proceed."; },
    createStep: function(d) { return "Create"; },
    confirmStep: function(d) { return "Confirm"; },
    collectionStep: function(d) { return "Return"; },
    completeStep: function(d) { return "Complete"; },
    exit: function(d) { return "Are you sure you want to leave this page and cancel your request"; },
    productCode: function(d) { return "Product Code"; },
    viewMoreDetails: function(d) { return "View more details"; },
    customerCare: function(d) { return "Items are no longer available to return or exchange. Please contact " + d.customerService + " for help."; },
    customerService: function(d) { return "Customer Care"; },
    yourExchangesInfo: function(d) { return "Your Exchange number is:"; },
    createdExchangesTitle: function(d) { return "You created an Exchange"; },
    createdExchangesInfo: function(d) { return "You have created one or more Exchanges on items in this order."; },
    createdReturnsTitle: function(d) { return "You created a Return"; },
    createdReturnsInfo: function(d) { return "You have created one or more Returns on items in this order."; },
    finalSale: function(d) { return "Final Sale. This item is non-returnable"; },
    orderStatus: function(d) { return "Order Status"; },
    splitShipmentMessage: function(d) { return "As your purchase contains an item coming from one of our other locations, they will be dispatched and delivered separately."; },
    shippingMethodName: function(d) { return select(d.method, { STANDARD: "Standard Delivery", EXPRESS: "Express Delivery", SATURDAY_DELIVERY: "Saturday Delivery Delivery", NEXT_DAY_DELIVERY: "Next Day Delivery", KIALA_STANDARD: "Kiala Delivery", DELIVER_TO_STORE: "Deliver to Store", PREMIER_DAYTIME: "Premier Daytime Delivery", other: "" }); },
    delayMessage: function(d) { return select(d.country, { GB: "Please ensure you fill out the three returns proforma invoices that came with your parcel when returning your order to ensure smooth clearance with customs and to avoid delays to your refund. For more information, [view our Return Policy](https://www.theoutnet.com/en-gb/page/help/returns/).", other: "" }); },
    paidReturnFeeInfo: function(d) { return "You have " + d.returnWindow + " days from the day your order is delivered to request an exchange or return and send your purchase back. Please note that if you return items, a fee of " + d.returnFee + " + tax will be deducted from your refund. [Discover More](/" + d.locale + "/page/help/returns/)"; },
    freeReturnFeeInfo: function(d) { return ""; }
  },
  createCollection: {
    bookCollection: function(d) { return "Book Your Collection"; },
    returnLabelBtn: function(d) { return select(d.hasRequested, { true: "Return label requested", other: "Request Return Label" }); },
    returnLabelInfo: function(d) { return "You should have received your return paperwork in your parcel. If you have misplaced your returns proforma invoice, please contact us [here](/" + d.locale + "/page/help/contact/). To request a new return label, please click below."; },
    returnLabelSuccess: function(d) { return "Your return label is being generated. We will send it to the email associated with this account in the next 24 hours."; },
    returnLabelError: function(d) { return select(d.error, { ERR_UNABLE_TO_REPRINT_LABEL: "Please note that you cannot make more than one request in a day, as the return documents can take up to 24 hours to be generated.", ERR_BAD_RESPONSE_FROM_EXTERNAL_SYSTEM: "Sorry, our system is temporarily unavailable. Please check back in a few hours and try again.", ERR_EXTERNAL_SALESFORCE_SERVICE_UNAVAILABLE: "Sorry, our system is temporarily unavailable. Please check back in a few hours and try again.", other: "Sorry, our system is temporarily unavailable. Please contact Customer Care for further assistance." }); },
    title: function(d) { return "Return Your Order"; },
    subTitle: function(d) { return "How would you like to return?"; },
    optionCollection: function(d) { return "Arrange a collection"; },
    optionDropOff: function(d) { return "At your closest drop off point"; },
    submit: function(d) { return "Continue"; },
    courierTimingMessage: function(d) { return "The earliest available collection is:"; },
    courierTimingSelectedMessage: function(d) { return "This is your chosen collection date:"; },
    selectDateLabel: function(d) { return "Select a day"; },
    addressMessage: function(d) { return "It'll be collected from:"; },
    specialInformationMessage: function(d) { return "Additional instructions for the courier"; },
    boxQuantityMessage: function(d) { return "How many boxes are you returning?"; },
    skipReturn: function(d) { return "I'll arrange my return later"; },
    returnComplete: function(d) { return "All done!"; },
    dropOffRequested: function(d) { return "You've requested to drop off your return"; },
    courierServicePoint: function(d) { return "Find your closest Service Point"; },
    returnConfirmationNumber: function(d) { return "Return Confirmation Number: "; },
    collectionTime: function(d) { return "You requested a collection for"; },
    parcelQuantity: function(d) { return "Number of boxes: "; },
    contactCustomerCare: function(d) { return "If you wish to use a different address, or book a different time, complete this step with our Customer Care Team on " + d.phone + " or " + d.mail + "."; },
    error: function(d) { return select(d.createError, { timeSlotError: "The time slot you’ve chosen has already expired. Please pick another one.", other: "We are having difficulties communicating with the courier. Alternatively you can contact our customer care team to book a collection or book directly on the courier's website" }); },
    maxLength: function(d) { return "Must be " + d.characters + " characters or less"; },
    chooseAnotherDay: function(d) { return "Not in? Choose another day"; },
    chosenDayNotAvailable: function(d) { return "Sorry, that date isn’t available. Please choose another."; },
    timeSlot: {
      now: function(d) { return "now"; },
      betweenTimeSlot: function(d) { return "between " + d.pickupTime + " - " + d.pickupLatest; },
      today: function(d) { return "Today"; },
      tomorrow: function(d) { return "Tomorrow"; },
      monday: function(d) { return "Monday"; },
      tuesday: function(d) { return "Tuesday"; },
      wednesday: function(d) { return "Wednesday"; },
      thursday: function(d) { return "Thursday"; },
      friday: function(d) { return "Friday"; },
      saturday: function(d) { return "Saturday"; },
      sunday: function(d) { return "Sunday"; }
    }
  },
  orderTracking: {
    trackDetails: function(d) { return "Track Your Order"; },
    subTitle: function(d) { return "Follow your purchase from the moment it leaves us until it arrives at your door"; },
    estimatedDeliveryDateInfo: function(d) { return "We will let you know the estimated delivery date once your purchase has left us"; },
    estimatedDeliveryDateInfoPremier: function(d) { return "Once your purchase has left us, we'll be in touch via phone or email with a delivery window"; },
    estimatedDeliveryDate: function(d) { return "Estimated delivery date:"; },
    deliveredOn: function(d) { return "Delivered on: "; },
    order: function(d) { return "Order #" + d.orderId; },
    trackingLink: function(d) { return "View Courier Tracking"; },
    courierTrackingNumber: function(d) { return "Enter your tracking number " + d.trackingNumber + " to follow your order on our courier's site. "; },
    trackingDetails: function(d) { return "Tracking details"; },
    delivered: function(d) { return "Delivered " + d.timeShipped; },
    dispatched: function(d) { return "Dispatched " + d.timeShipped; },
    processing: function(d) { return "Processing"; }
  },
  returnTracking: {
    trackDetails: function(d) { return "Track Your Return"; },
    subTitle: function(d) { return "From your door all the way to ours, keep track of your return "; },
    estimatedRefundDateInfo: function(d) { return "We aim to process your return within 3 working days of receiving your order and will be in touch again when your refund has been issued"; },
    trackingLink: function(d) { return "View Courier Tracking"; },
    returnedToWarehouseOn: function(d) { return "Returned to the warehouse on: "; },
    partialReturn: function(d) { return "Part of your return has not been accepted. For more information, take a look at your order details or contact Custome Care by " + d.phone + " or " + d.mail; },
    courierTrackingNumber: function(d) { return "Enter your tracking number " + d.trackingNumber + " to follow your return on our courier's site. "; }
  },
  guestOrderTracking: {
    trackOrder: {
      title: function(d) { return "Track Your Order"; },
      info: function(d) { return "Enter your order number in the box below to review your purchase and view its delivery status."; },
      helpInfo: function(d) { return "If you’ve just placed an order, it will take a few minutes to update."; },
      error: function(d) { return "Sorry, there’s no order matching the order number you entered. Please check and try again"; },
      lables: {
        email: function(d) { return "Email address"; },
        orderId: function(d) { return "Order number:"; },
        button: function(d) { return "Track"; }
      }
    },
    trackReturn: {
      title: function(d) { return "Track Your Return"; },
      info: function(d) { return "Enter your order number in the box below to review your return status."; },
      helpInfo: function(d) { return "If you’ve just submitted a return, it will take a few minutes to update."; },
      error: function(d) { return "Sorry, there’s no return matching the order number you entered. Please check and try again"; },
      lables: {
        email: function(d) { return "Email address:"; },
        orderId: function(d) { return "Order number:"; },
        button: function(d) { return "Track"; }
      }
    },
    createReturn: {
      title: function(d) { return "Create a Return"; },
      info: function(d) { return "You can create a return and send back your purchase within " + d.returnWindow + " days of receipt. Plus, we'll come and collect from your home, work or alternate address."; },
      proformaInfo: function(d) { return "Please ensure you fill out the returns proforma invoices that came with your parcel when returning your order to ensure smooth clearance with customs. "; },
      helpInfo: function(d) { return "Items should be returned new, unused and with all THE OUTNET and designer garment tags still attached. For more information, [view our Returns Policy](/" + d.locale + "/page/help/returns/)."; },
      error: function(d) { return "Sorry, there’s no order matching the order number you entered. Please check and try again"; },
      lables: {
        email: function(d) { return "Email address:"; },
        orderId: function(d) { return "Order number:"; },
        button: function(d) { return "Start Return"; }
      },
      notReturnable: function(d) { return "Sorry, this order can’t be returned. Please view our Returns Policy for more information, you may view the order here: "; }
    }
  },
  marketing: {
    subscribeCta: function(d) { return "Subscribe Now"; },
    updatePreferencesCta: function(d) { return "Update Preferences"; },
    manageSubscriptionsCta: function(d) { return "Manage Subscriptions"; },
    moreDetails: function(d) { return "For further information on how we process your data, please read our [Privacy Policy](/" + d.locale + "/page/policies/privacy-policy/)"; },
    updateError: function(d) { return "Unable to update Email Preferences. Please try again later."; }
  },
  unsubscribe: {
    viewAll: function(d) { return "View all our brands"; },
    allBrands: function(d) { return "All brands"; },
    unsubscribeBtn: function(d) { return "Unsubscribe"; }
  },
  price: {
    original: function(d) { return "Price"; },
    discountPercentage: function(d) { return "(-" + d.discountPercentage + "%)"; },
    wasPriceOriginal: function(d) { return "RRP: " + d.wasPrice; },
    wasPrice: function(d) { return "RRP:"; },
    originalPrice: function(d) { return "Original price:"; },
    discountApplied: function(d) { return "Discount Applied:"; },
    itemTax: function(d) { return select(d.included, { true: "Including ", other: "" }) + "Tax: "; },
    tax: function(d) { return "Tax: "; },
    duties: function(d) { return select(d.included, { true: "Including ", other: "" }) + "Duties: "; },
    final: function(d) { return "Item Total"; },
    promoApplied: function(d) { return select(d.description, { undefined: "Promotion", other: d.description }) + " applied"; },
    salesTax: function(d) { return "Tax: "; }
  },
  purchasePath: {
    edit: function(d) { return "Edit"; }
  },
  orderPaymentSummary: {
    shippedTo: function(d) { return "Shipped To"; },
    shippingMethod: function(d) { return "Shipping Method"; },
    billedTo: function(d) { return "Billed To"; },
    shippingMethodName: function(d) { return select(d.method, { STANDARD: "Standard", EXPRESS: "Express", SATURDAY_DELIVERY: "Saturday Delivery", NEXT_DAY_DELIVERY: select(d.country, { GB: "Express", other: "Next Day" }), KIALA_STANDARD: "Kiala", DELIVER_TO_STORE: "Deliver to Store", PREMIER_DAYTIME: "Premier Daytime", other: "" }); },
    paymentType: function(d) { return select(d.type, { CREDIT_CARD: "Credit Card", PAYPAL: "PayPal", PAYPAL_EXPRESS: "PayPal Express", ALIPAY: "AliPay", PAYEASE: "Pay Ease", PAYEASE_INTERNATIONAL: "Pay Ease Internation", COD: "Cash on Delivery", WIRE_TRANSFER: "Wire Transfer", SOFORT: "Sofort", STORE_CREDIT: "Store Credits", KLARNA_PAY_NOW: "Pay Now", KLARNA_PAY_LATER: "Pay in 30 days", KLARNA_SLICE_IT: "Pay in instalments", other: "" }); }
  },
  lineItem: {
    quantity: function(d) { return "Quantity: "; }
  },
  cardWallet: {
    title: function(d) { return "Card Wallet"; },
    description: function(d) { return "View and manage your payment methods"; },
    emptyListTitle: function(d) { return "You don't have any saved cards"; },
    emptyListDetails: function(d) { return "Add a card to check out more quickly"; },
    addCard: function(d) { return "Add a card"; },
    edit: function(d) { return "Edit"; },
    "delete": function(d) { return "Delete"; },
    cancel: function(d) { return "Cancel"; },
    success: function(d) { return select(d.method, { ADD: "You have added the card ending in " + d.cardLastFour, EDIT: "You have updated the card ending in " + d.cardLastFour, DELETE: "You have deleted the card ending in " + d.cardLastFour, other: "" }); },
    deleteTitle: function(d) { return "Delete Card"; },
    deletePrompt: function(d) { return "Are you sure you want to delete this card ending in " + d.cardNumber + "?"; },
    deleteError: function(d) { return "There was an error deleting the card ending in " + d.cardNumber; },
    pageError: function(d) { return "We're sorry something went wrong."; },
    retryButton: function(d) { return "Retry Now"; }
  },
  creditCardForm: {
    success: function(d) { return select(d.method, { ADD: "You have added the card ending in " + d.cardLastFour, DELETE: "You have deleted the card ending in " + d.cardLastFour, other: "" }); },
    title: function(d) { return select(d.method, { ADD: "Add a card", EDIT: "Edit card details", other: "" }); },
    number: function(d) { return "Card Number"; },
    cardHolderName: function(d) { return "Name On Card"; },
    expiryDate: function(d) { return "Expiry Date"; },
    month: function(d) { return "Month"; },
    monthPlaceholder: function(d) { return "MM"; },
    year: function(d) { return "Year"; },
    cardDetails: function(d) { return "Card details"; },
    yearPlaceholder: function(d) { return "YY"; },
    cvv: function(d) { return d.cvvType; },
    cvvHelp: function(d) { return plural(d.cvvSize, 0, en, { "0": "Security code ", other: number(d.cvvSize, "cvvSize") + " numbers" }) + " on the " + select(d.cvvType, { CID: "front", other: "back" }) + " of your card"; },
    submit: function(d) { return "Save"; },
    privacyPolicy: function(d) { return "The card information you provide will be used by THE OUTNET to speed up your purchasing process. Please consult our [Privacy Policy](/" + d.locale + "/page/policies/privacy-policy/) for further information about your rights."; },
    acceptedCards: function(d) { return "Accepted cards"; },
    error: function(d) { return "We're sorry something went wrong."; }
  },
  card: {
    expiry: function(d) { return "Expiry"; },
    expired: function(d) { return "Expired"; },
    cardHolder: function(d) { return "Card Holder"; }
  },
  customerCare: {
    service: function(d) { return ""; },
    customerCare: function(d) { return "24/7 Customer Care"; },
    customerCareDetails: function(d) { return "Our team is here to help with anything from sizing to styling"; },
    callUs: function(d) { return "Call us"; },
    emailUs: function(d) { return "Email us"; },
    returns: function(d) { return "Easy Returns"; },
    returnsDetails: function(d) { return "If your purchase isn’t quite right, it’s easy to return"; },
    returnsLink: function(d) { return "Find Out More"; },
    delivery: function(d) { return "Global Delivery"; },
    deliveryDetails: function(d) { return "We deliver to over 100 locations"; },
    deliveryLink: function(d) { return "View Delivery Options"; }
  },
  months: {
    january: function(d) { return "January"; },
    february: function(d) { return "February"; },
    march: function(d) { return "March"; },
    april: function(d) { return "April"; },
    may: function(d) { return "May"; },
    june: function(d) { return "June"; },
    july: function(d) { return "July"; },
    august: function(d) { return "August"; },
    september: function(d) { return "September"; },
    october: function(d) { return "October"; },
    november: function(d) { return "November"; },
    december: function(d) { return "December"; }
  },
  errors: {
    maxLength: function(d) { return select(d.selectMessageField, { zipcodeKR: "Must be 5 characters", other: "Must be " + d.characters + " characters or less" }); },
    minLength: function(d) { return select(d.selectMessageField, { zipcodeKR: "Must be 5 characters", other: "Must be " + d.characters + " characters or more" }); },
    containsWhitespace: function(d) { return "Contains whitespace"; },
    characterOccurrence: function(d) { return "Your password must not contain a character that is used more than " + d.occurrence + " times"; },
    characterRepeats: function(d) { return "Your password must not contain more than " + d.repeats + " consecutive characters"; },
    containsLogonId: function(d) { return "Password cannot contain your logonId"; },
    containsPassword: function(d) { return "Password cannot contain password"; },
    invalid: function(d) { return "Invalid " + d.field + " provided"; },
    invalidField: function(d) { return "Please check the field for invalid characters"; },
    required: function(d) { return select(d.selectMessageField, { phone1: "Your mobile number is required to receive SMS order status updates for The Outnet deliveries", other: select(d.field, { undefined: "Required", other: d.field + " is required" }) }); },
    invalidZipCode: function(d) { return select(d.country, { US: "Invalid zip code", other: "Invalid post code" }); },
    invalidState: function(d) { return "Invalid state"; },
    invalidDob: function(d) { return "Please enter your date of birth in the format (" + select(d.country, { US: "MM/DD/YYYY", other: "DD/MM/YYYY" }) + ")"; },
    underAge: function(d) { return "You must be at least 14 years old"; },
    invalidPccc: function(d) { return select(d.field, { TAX_ID: "Please enter a valid TAX ID", PCCC: "Enter your PCCC number (e.g. P + 12 digits)", other: "Invalid " + d.name + " provided" }); },
    generic: function(d) { return "Oops, something's not right. Try again later."; },
    fieldErrors: function(d) { return "Please check the following information again:"; },
    global: function(d) { return "There was a problem. Try again later."; },
    authenticationError: function(d) { return "The specified logon or password are not correct"; },
    loginNotAllowed: function(d) { return "You have to wait " + d.time + " " + d.timeUnit + " before you can log in again."; },
    timeUnit: function(d) { return select(d.type, { HOUR: "hour", HOURS: "hours", MINUTES: "minutes", SECONDS: "seconds", other: "" }); },
    userExists: function(d) { return "User already exists"; },
    passwordsDontMatch: function(d) { return "Passwords do not match"; },
    phoneRequired: function(d) { return "Your mobile number is required to receive SMS order status updates for The Outnet deliveries"; },
    mustContainNumber: function(d) { return "Your password must contain at least " + plural(d.occurrence, 0, en, { one: "one number", other: number(d.occurrence, "occurrence") + " numbers" }); },
    mustContainLetter: function(d) { return "Your password must contain at least " + plural(d.occurrence, 0, en, { one: "one letter", other: number(d.occurrence, "occurrence") + " letters" }); },
    mustContainUppercase: function(d) { return "Your password must contain at least one uppercase letter"; },
    passwordsMatch: function(d) { return "New password must be different from old password"; },
    reuseOldPassword: function(d) { return "The password entered was previously used. Enter a new password"; },
    expiredValidationCode: function(d) { return "Sorry, your validation code has expired"; },
    invalidValidationCode: function(d) { return "Please try resetting your password again"; },
    blocklistedPassword: function(d) { return "Sorry, you can not use that password"; },
    updateNotAllowed: function(d) { return "You have to wait " + d.timeToWait + " hours before you can try again"; },
    goBack: function(d) { return "Go Back"; },
    pcccRequired: function(d) { return "Enter your PCCC number (e.g. P + 12 digits)"; },
    swiftCode: function(d) { return "Your SWIFT code must be between 8 and 11 characters"; },
    ibanCode: function(d) { return "Your IBAN code must be between 5 and 34 characters long and contain only alphanumeric characters"; },
    returnError: function(d) { return "Sorry, we weren't able to complete your return request. Please try again or contact Customer Care"; },
    exchangeError: function(d) { return "Sorry, we weren't able to complete your exchange request. Please try again or contact Customer Care"; },
    duplicateReturnError: function(d) { return "It looks like you've already requested a return for this order. To make any amendments, please contact Customer Care"; },
    invalidOrderItem: function(d) { return "Sorry, this item can't be returned"; },
    invalidOrder: function(d) { return "Sorry, this order can't be returned"; },
    invalidCharacters: function(d) { return "Sorry, we're unable to accept " + d.nonLatin; },
    meetRequirements: function(d) { return "Please check the password you’ve entered meets the above requirements"; },
    zipCodeDoesNotMatchState: function(d) { return "Please check your " + d.zip; },
    refundPaymentMethod: function(d) { return "Please select refund return method"; },
    changeCountryNotAllowedError: function(d) { return "This order was shipped to a different country/region. To create your exchange or return, please amend your location to match where you purchased from and try again"; },
    eircode: function(d) { return "Must be a 7-character alpha-numeric code, e.g. A65 F4E2. For information visit www.eircode.ie"; }
  },
  retry: {
    title: function(d) { return "We're sorry, this page isn't available."; },
    retrynow: function(d) { return "Retry now"; },
    timetoretry: function(d) { return "We'll try and reconnect you in " + d.seconds + " seconds..."; },
    retryingnow: function(d) { return "Retrying now"; }
  },
  totals: {
    itemTotal: function(d) { return "Item Subtotal"; },
    shipping: function(d) { return "Shipping"; },
    shippingPrice: function(d) { return select(d.isFree, { true: "FREE", other: d.price }); },
    packaging: function(d) { return "Packaging"; },
    total: function(d) { return "Total"; },
    remove: function(d) { return "Remove"; },
    tax: function(d) { return "Tax"; },
    duty: function(d) { return "Duties"; }
  },
  personalInfoForm: {
    personTitle: function(d) { return "Title"; },
    firstName: function(d) { return "First Name"; },
    lastName: function(d) { return "Last Name"; },
    dob: function(d) { return "Date of Birth (Optional)"; },
    submit: function(d) { return "Update"; },
    dayPlaceholder: function(d) { return "DD"; },
    monthPlaceholder: function(d) { return "MM"; },
    yearPlaceholder: function(d) { return "YYYY"; },
    other: function(d) { return "Other"; },
    selectTitle: function(d) { return "Select title"; },
    dobHelp: function(d) { return ""; },
    day: function(d) { return "day"; },
    month: function(d) { return "month"; },
    year: function(d) { return "year"; }
  },
  greetings: {
    morning: function(d) { return "Good Morning " + d.firstName; },
    afternoon: function(d) { return "Good Afternoon " + d.firstName; },
    evening: function(d) { return "Good Evening " + d.firstName; }
  },
  product: {
    infoUnavailable: function(d) { return "We can not retrieve all the product information at this time. Please check your order confirmation email for full details."; }
  },
  help: {
    passwordRules: function(d) { return "Your password must be eight characters or more and contain an uppercase letter and number"; }
  },
  loginAdditionalMessages: {
    addToWishlist: {
      message: function(d) { return "To save this item in your Wish List, please register or log in"; }
    },
    restrictedPage: {
      message: function(d) { return "Get exclusive access by signing into your account"; }
    }
  },
  referrals: {
    title: function(d) { return "Refer a Friend"; },
    landingTitle: function(d) { return "Welcome to THE OUTNET"; },
    error: function(d) { return "We're sorry, there was a problem loading this page"; },
    errorAction: function(d) { return "Go back"; },
    cookieMessage: function(d) { return "Oops! Your browser isn't accepting cookies. Please enable your cookies to view this page."; }
  },
  cod: {
    refund: function(d) { return "As you placed this order using Cash on Delivery, we need to take your bank details to be able to give you a refund."; },
    bankNameFieldName: function(d) { return "Bank Name"; },
    accountNameFieldName: function(d) { return "Account Holder"; },
    swiftCodeFieldName: function(d) { return "BIC / SWIFT Code"; },
    accountNoFieldName: function(d) { return "IBAN Code"; }
  },
  credits: {
    remainingCredit: function(d) { return "Remaining Credit:"; },
    transactions: function(d) { return "Transactions"; },
    error: function(d) { return "Sorry, we couldn't find your store credit details"; },
    title: function(d) { return "Store Credit"; },
    noStoreCredit: function(d) { return "You don't have any store credit"; },
    allTransactions: function(d) { return "All Transactions"; },
    viewAll: function(d) { return "View All"; },
    subheading: function(d) { return "Check your balance and transactions."; },
    closeTransactions: function(d) { return "Close"; }
  },
  giftcards: {
    title: function(d) { return "Gift Cards"; },
    info: function(d) { return "For assistance redeeming a Gift Card, please call Customer Care 24/7 on " + d.countryPhoneLink + "."; },
    noGiftCard: function(d) { return "You have no gift card"; }
  },
  privacy: {
    version: function(d) { return "Version " + d.version; },
    read: function(d) { return "Read by you on " + d.consentTime; },
    pageError: function(d) { return "Sorry, something went wrong"; },
    retryButton: function(d) { return "Try again"; }
  },
  privacyCloseAccount: {
    title: function(d) { return "Close Account"; },
    confirmationBody: function(d) { return "Are you sure you want to close your account?"; },
    acknowledgingBodyBp1: function(d) { return "Thank you for submitting your request."; },
    acknowledgingBodyBp2: function(d) { return "We will delete your account and all related personal data as soon as possible and notify you within 30 days."; },
    confirmButton: function(d) { return "Close Account"; },
    cancelButton: function(d) { return "Cancel"; }
  },
  tcOverlay: {
    title: function(d) { return "YOOX NET-A-PORTER Group S.p.A. and The Net-A-Porter Group Limited collect and use your personal information as follows:"; },
    footer: function(d) { return "For further information, please read our [Privacy Policy](/" + d.locale + "/page/help/privacy-policy/)."; },
    newsletterTitle: function(d) { return "We collect and use your personal information as follows:"; },
    newsletterFooter: function(d) { return "*LuxExperience B.V. includes the following brands: Mr Porter, Mytheresa, Net-A-Porter, The Outnet, YOOX.\n\nWhen you visit, use our websites and/or applications, including services provided thereon, your information will be processed in accordance with the respective Privacy Policy of each brand: [Mr Porter](https://www.mrporter.com/content/help/privacy-policy/), [Mytheresa](https://www.mytheresa.com/to/service/privacy-policy), [Net-A-Porter](https://www.net-a-porter.com/content/help/privacy-policy/), [The Outnet](https://www.theoutnet.com/page/policies/privacy-policy/), [YOOX](https://www.yoox.com/Legal/Privacypolicy)."; }
  },
  tcParagraphs: {
    pg1: function(d) { return "Purposes of collection and use of personal information: identification of users; verification of eligibility for subscription; prevention of fraudulent subscription and fraud; execution and performance of purchase agreements for products; provision of services provided by the website and the Apps; response to customer requests and inquiries; exercise or defense of legal claims, statistical analysis and survey; and performance of obligations under applicable laws and regulations."; },
    pg2: function(d) { return "Items of Personal Information to be collected."; },
    "pg2-1": function(d) { return "[When signing up for membership] Name, surname, email address, password, service usage history and, if provided by the user, date of birth, gender and phone number."; },
    "pg2-2": function(d) { return "[When purchasing products] Order history, delivery address, invoice address, phone number, payment details."; },
    pg3: function(d) { return "Period of retention and use of personal information: Information collected at the time of membership registration will be retained and used until a request for withdrawal is made, and information collected to conclude and execute a purchase contract for a product will be stored in accordance with applicable tax legislation until the conclusion of all administrative and accounting formalities (ten years)."; }
  },
  newsletterTcParagraphs: {
    pg1: function(d) { return "Purpose of collection and use of personal information: Transmission of newsletters and advertisements, customised promotional and marketing communications via email from LuxExperience B.V.* brands to improve user shopping experience."; },
    pg2: function(d) { return "Items of personal information to be collected: Name, email address, gender, date of birth, phone number, order history, browsing habits."; },
    pg3: function(d) { return "Period of retention and use of personal information: To the extent permitted by applicable laws and regulations, personal information will be processed until you withdraw your consent or request your membership withdrawal or, with specific regard to the customisation of the communications, you disable the cookies. Any other information required to be preserved under applicable laws and regulations shall be preserved for the period set forth under such laws and regulations."; }
  }
}